// extracted by mini-css-extract-plugin
export default {"number":"PhoneLink_number__d-6GC"};